import { Collapse } from '@material-ui/core'
import { IPointElemProps } from '@root-gipro/modules/userProjects/models/interfaces/project-unc-add.props'
import {
	changeUncCheckedTable,
	fetchUncTableData,
	selectTableElem,
} from '@root-gipro/modules/userProjects/store/actions'
import { IUncTableElem } from '@root-gipro/store/interfaces'
import { IState } from '@root-gipro/store/interfaces/state'
import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const PointElem: React.FC<IPointElemProps> = ({ name, uncMainIds, num }) => {
	const [open, setOpen] = useState<boolean>(false)
	const { uncMains } = useSelector((state: IState) => state.public)
	const { unc_sort } = useSelector((state: IState) => state.userProjects.projectObj)
	const { uncCheckedTable } = useSelector((state: IState) => state.userProjects)
	const dispatch = useDispatch()
	const filteredUnc = useMemo(() => {
		return uncMains.filter((elem: { id: number }) => uncMainIds.includes(elem.id))
	}, [uncMains, uncMainIds])

	return (
		<div className={open ? 'collapsed point_elem' : 'point_elem'}>
			<div onClick={() => setOpen(!open)} className='point_name'>
				<span className='table_num'>{num}. </span>
				{name}
			</div>
			<Collapse in={open} timeout='auto' unmountOnExit>
				{filteredUnc.map((unc: IUncTableElem) => {
					return (
						<div
							onClick={() => {
								dispatch(selectTableElem(unc))

								if (uncCheckedTable === 8) dispatch(changeUncCheckedTable(1))

								unc_sort && dispatch(fetchUncTableData(unc.id, unc_sort))
							}}
							key={unc.id}
							className='point'
						>
							<span className='table_num'>{unc.code}.</span>
							{unc.name}
						</div>
					)
				})}
			</Collapse>
		</div>
	)
}
